import i18n from './reacti18n';

export const mappingRemoteConfig = {
  callUs: 'callUs',
  email: 'email',
  liveChat: 'chat',
  chatBot: 'chat',
  messageUs: 'messageUs',
  chat: 'chat',
};

/**
 * Step Up Kill Switch.
 * To check whether the selected channel is enabled in remote config.
 * @param fromChannel
 * @returns {boolean}
 */
export const isStepUpEnabled = (fromChannel) => {
  const stepUpConfig = window.stepUpConfig;
  if (typeof stepUpConfig === 'object' && typeof stepUpConfig.stepUpEnabled === 'object') {
    return stepUpConfig.stepUpEnabled[mappingRemoteConfig[fromChannel]];
  }
  return false;
};

/**
 * Function to check is topicId exists in locale property file.
 * @param topicRefId
 * @returns {boolean} true/false
 */
export const isTopicSupportedForRisk = (topicRefId) => {
  const key = `smarthelp.authStepUpPrompt.${topicRefId}`;
  const topicLabel = i18n.message(key);
  return topicLabel !== key;
};

// TODO:: Move this to globalHelper file during chat/chat bot clean up.
export const isFinalIntent = (selectResultTopic) => {
  if (typeof selectResultTopic === 'object') {
    return !!(selectResultTopic && selectResultTopic.topicRefId);
  }
  return false;
};
